<template>
  <b-card-code title="Status Rekomendasi">
    <app-timeline>
      <app-timeline-item
        v-for="(item, key) in timelineData"
        :key="key"
        :title="item.email"
        :subtitle="item.message"
        :time="item.durasi"
        :variant="item.is_ok == 'ya' ? 'success' : 'warning'"
      />
    </app-timeline>
  </b-card-code>
</template>


<script>
import BCardCode from '@core/components/b-card-code'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  getPerekomendasi,
} from '@/connection-api/lembarkehidupan'

export default {
  components: {
    BCardCode,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      timelineData: {},
    }
  },
  async mounted() {
    // Fetch the JSON data and assign it to timelineData
    try {
      const response = await getPerekomendasi();
      this.timelineData = response.data.data;
    } catch (error) {
      console.error(error);
    }
  },
}
</script>
